import $ from 'jquery';
import XConstants from '../../core/config/Constants';
import { useEffect, useState } from 'react';
import 'datatables.net';
import 'datatables.net-bs4';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import { toast } from 'react-hot-toast';
import {UserService} from "./Service";
import {checkPermission} from "../../core/routes/RouteValidator";
import {useSelector} from "react-redux";

const ManageUsers = () => {
    const user = useSelector((state: any) => state.auth);
    const company = useSelector((state: any) => state.company);
    const [service] = useState(new UserService());
    const navigate = useNavigate();
    const location = useLocation();

    const getItems = () => {
        try {
            $('#items').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token');
        $('#items').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data, type, row) {
                        if (data) {
                            return `<img src="${data}" alt="${row[1]}" width="50" height="50" />`;
                        } else {
                            return `<img src="https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${row[1]}&size=40&rounded=true"  alt="${row[1]}" width="50" height="50" />`;
                        }
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 0
                },
                {

                    "render": function (data: string, type: any, row: any) {
                        if (data === 'Active') {
                            return `<p class="badge bg-success p-2 rounded-3">Active</p>`;
                        } else {
                            return `<p class="badge bg-danger p-2 rounded-3">Inactive</p>`;
                        }
                    },
                    "targets": 5
                },
                {

                    "render": function (data: any, type: any, row: string[]) {
                        if (row[5] === 'Active') {
                            return `<button class="btn btn-danger">Deactivate</button>`;
                        } else {
                            return `<button class="btn btn-success">Activate</button>`;
                        }
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            const status = rowData[5] === 'Active' ? 'Inactive' : 'Active'
                            const res = await service.updateUser({
                                id: rowData[7],
                                status: status
                            });
                            if (res) {
                                toast.success("User updated successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 7
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-primary">Details</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click((e: any) => {
                            navigate(`${location.pathname}/details/${cellData}`);
                        })
                    },
                    "targets": 8
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-danger">Delete</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            const res = await service.updateUser({
                                id: rowData[9],
                                deleted: true
                            });
                            if (res) {
                                toast.success("User deleted successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 9
                },
            ],
            ajax: {
                url: `${XConstants.baseUrl}/company/user/list`,
                type: 'POST',
                contentType: 'application/json',
                headers: {
                    'Authorization': token,
                },
                data: function(d: any) {
                    return JSON.stringify({
                        ...d,
                    });
                },
            },
        });
    };

    useEffect(() => {
        getItems();
    }, []);


    return (<>
        <div className="page-header">
            <div className="content-page-header">
                <h5>Users</h5>
                <div className="list-btn">
                    <ul className="filter-list">
                        <li>
                            <div
                                className="dropdown dropdown-action"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Download"
                            >
                                <a
                                    href="#"
                                    className="btn-filters"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
              <span>
                <i className="fe fe-download"/>
              </span>
                                </a>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <ul className="d-block">
                                        <li>
                                            <a
                                                className="d-flex align-items-center download-item"
                                                href="javascript:void(0);"
                                                download=""
                                            >
                                                <i className="far fa-file-text me-2"/>
                                                CVS
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                        {(checkPermission(user, company, '/users/add')) && <li>
                            <Link className="btn btn-primary" to={'/users/add'}>
                                <i className="fa fa-plus-circle me-2" aria-hidden="true"/>
                                Add User
                            </Link>
                        </li>}
                    </ul>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="card col-12">
                <div className="card-body w-100">
                    <div className="table-responsive w-100">
                        <table
                            id="items"
                            className="table datatable  w-100"
                        >
                            <thead>
                            <tr>
                                <th>Profile Pic</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Role</th>
                                <th>Status</th>
                                <th>Added Date</th>
                                <th>Change Status</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div>
    </>);
};

export default ManageUsers;
